import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import moment from 'moment'

@Component({
  selector: 'app-time-column-renderer',
  template: ` {{ processTime() }} `,
  standalone: false
})
export class TimeColumnRendererComponent implements AgRendererComponent {
  private params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  processTime(): string {
    return moment(this.params.value).format('LT')
  }
}
